<template>
  <div class="dialog"
       @touchstart="onTouchStart"
       @mousedown="onMouseDown"
       @touchend="onTouchEnd"
       @touchcancel="onTouchEnd"
       @mouseup="onMouseUp"
       @mouseleave="onMouseUp">
    <div
      id="detaildialog"
      @click.stop
      @touchmove="onTouchMove"
      @mousemove="onMouseMove">
      <div
        v-for="(item,index) in copyLists"
        :key="index"
        class="swiperitem"
        :style="cardStyles[index]">
        <slot :item="item"
              :index="index"
              name="swiper"></slot>
      </div>
      <slot name="pagination" :realIndex="realIndex"></slot>
      <slot name="close">

      </slot>
    </div>
  </div>
</template>
<script>
import TWEEN from '@tweenjs/tween.js';
import ZingTouch from 'zingtouch';
let animation;
const ratio = 1/window.innerWidth *40
export default {
  name: 'aibeeSwiper',
  data() {
    return {
      mouse: {
        state: 'idle',
        sx: 0,
        sy: 0,
        cx: 0,
        cy: 0,
        listeners: {},
        index: 0,
        isForward: true
      },
      currentIndex: 0,
      currentEasing: null,
      zingInitialized: false,
      realIndex: 0,
      pendingEasing: null,
      copyLists: []
    };
  },
  props: {
    list: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  components: {},
  watch: {
    currentIndex(val) {
      const l = this.list.length;
      const realIndex = (val - this.offset) % l;
      this.currentProduct = this.list[realIndex];
      if (this.currentProduct) {
        this.realIndex = realIndex;
        if (val < this.offset) this.currentIndex += l;
        if (val > l + this.offset - 1) this.currentIndex -= l;
      }
    }
  },
  computed: {
    cardStyles() {
      return this.copyLists.map((p, index) => {
        const { innerWidth } = window;
        const diff = Math.abs(index - this.currentIndex);
        
        const step = Math.min(2, this.list.length-1,diff); // 2张时 外漏1个 大于2张时 外漏2个
        const sign = Math.sign(index - this.currentIndex);
        const scale = 1 - (sign > 0 ? step * 0.1 : 0);
        let translate = `${(sign * 10 * step)}%`;
        if (sign < 0) {
          const s = Math.min(1, step);
          translate = `${sign * s * innerWidth}px`;
        }
        const style = {
          'z-index': 100 - index,
          transform: `translateX(${translate}) scale(${scale}, ${scale})`
        };
        if (index === 0)
          Object.assign(style, {
            position: 'relative'
          });
        return style;
      });
    }
  },
  created() {},
  mounted() {
    console.log(111)
    this.tick();
    this.pro();
  },
  methods: {
    pro() {
      const val = this.list;
      if (val && val.length) {
        const l = val.length;//两张卡片也循环
        if (l <= 1) {
          this.copyLists = val;
          this.offset = 0;
        } else {
          this.copyLists = [val[l - 2], val[l - 1], ...val, val[0], val[1]];
          this.offset = 2;
        }
        this.currentIndex = this.offset;
      } else {
        this.copyLists = [];
      }
    },
    tick() {
      TWEEN.update();
      if (this.pendingEasing) {
        if (this.currentEasing) this.currentEasing.stop();
        this.currentEasing = this.pendingEasing;
        this.currentEasing.start();
        this.pendingEasing = null;
      }
      if (this.mouse.state === 'idle') {
        if (Math.abs(this.prevIndex - this.currentIndex) < 0.005) {
          this.prevIndex = this.currentIndex;
          this.clock = new Date();
        } else if (Math.round(this.prevIndex) !== this.prevIndex) {
          if (new Date() - this.clock > 60) {
            this.clock = new Date();
            const targetIndex = Math.round(this.currentIndex);
            this.setEasing(
              new TWEEN.Tween({
                i: this.currentIndex
              })
                .to(
                  {
                    i: targetIndex
                  },
                  150
                )
                .easing(TWEEN.Easing.Quadratic.InOut)
                .onUpdate(({ i }) => {
                  this.currentIndex = i;
                })
                .onComplete(() => {
                  const l = this.list.length;
                  let t = targetIndex;
                  if (t < this.offset) t += l;
                  if (t > l + this.offset - 1) t -= l;
                  this.currentIndex = t;
                  this.unbindZing();
                }),
              false
            );
          }
        }
      }
      animation = requestAnimationFrame(() => {
        this.tick();
      });
    },
    onMove() {
      const { innerWidth } = window;
      const { sx, cx } = this.mouse;
      const diff = (cx - sx) / innerWidth;
      this.mouse.state = 'move';
      let targetIndex = this.mouse.index - diff;
      targetIndex = Math.min(targetIndex, this.copyLists.length - 1);
      targetIndex = Math.max(targetIndex, 0);
      this.mouse.isForward = diff < 0;
      this.currentIndex = targetIndex;
    },
    setEasing(tween, swipe) {
      if (swipe || !this.pendingEasing) this.pendingEasing = tween;
    },
    onTouchStart(e) {
      this.bindZing();
      if (e.targetTouches.length !== 1) return;
      this.mouse.state = 'down';
      this.mouse.sx = e.touches[0].pageX;
      this.mouse.sy = e.touches[0].pageY;
      this.mouse.index = this.currentIndex;
      if (this.currentEasing) this.currentEasing.stop();
    },
    onTouchMove(e) {
      
        if (this.mouse.state === 'idle') return;
        this.mouse.cx = e.touches[0].pageX;
        this.mouse.cy = e.touches[0].pageY;
        if(Math.abs(this.mouse.sx - this.mouse.cx) > Math.abs(this.mouse.sy - this.mouse.cy)){// 有效横向滑动 垂直和水平小于45度角 则认为是水平滑动，避免影响内嵌物垂直方向的内容滚动
          this.onMove();
          e.preventDefault();
        }
      
      
    },
    onTouchEnd(e) {
      this.mouse.state = 'idle';
      const i = parseInt(this.currentIndex)
      // const targetIndex = Math.round(this.currentIndex);
      let iff = (this.currentIndex - i) >ratio
      if(!this.mouse.isForward){
        iff = (this.currentIndex - i) > 1-ratio
      }
      
      const targetIndex = iff?i+1:i//Math.round(this.currentIndex);
      this.setEasing(
        new TWEEN.Tween({
          i: this.currentIndex
        })
          .to(
            {
              i: targetIndex
            },
            150
          )
          .easing(TWEEN.Easing.Quadratic.InOut)
          .onUpdate(({ i }) => {
            this.currentIndex = i;
          })
          .onComplete(() => {
            const l = this.list.length;
            let t = targetIndex;
            if (t < this.offset) t += l;
            if (t > l + this.offset - 1) t -= l;
            this.currentIndex = t;
            this.unbindZing();
          }),
        false
      );
    },
    bindZing() {
      const detaildialog = document.getElementById('detaildialog');
      const swipeGesture = new ZingTouch.Swipe({
        escapeVelocity: 0.2
      });

      if (!this.zingInitialized) {
        this.zt = new ZingTouch.Region(document.body, false, false);
        this.zingInitialized = true;
      }
  
      this.zt.bind(detaildialog, swipeGesture, (e) => {
        const { currentDirection } = e.detail.data[0];

        if (Math.abs(currentDirection - 180) < 90) {
          // index - 1
          const targetIndex = Math.ceil(this.currentIndex);
          this.setEasing(
            new TWEEN.Tween({
              i: this.currentIndex
            })
              .to(
                {
                  i: targetIndex
                },
                150
              )
              .easing(TWEEN.Easing.Quadratic.InOut)
              .onStart(() => {
                this.swipeEasing = true;
              })
              .onUpdate(({ i }) => {
                this.currentIndex = i;
              })
              .onComplete(() => {
                const l = this.list.length;
                let t = targetIndex;
                if (t < this.offset) t += l;
                if (t > l + this.offset - 1) t -= l;
                this.currentIndex = t;
                this.swipeEasing = false;
              }),
            true
          );
        } else if (Math.abs(currentDirection - 180) > 90) {
          // index + 1
          const targetIndex = Math.floor(this.currentIndex);
          this.setEasing(
            new TWEEN.Tween({
              i: this.currentIndex
            })
              .to(
                {
                  i: targetIndex
                },
                150
              )
              .easing(TWEEN.Easing.Quadratic.InOut)
              .onStart(() => {
                this.swipeEasing = true;
              })
              .onUpdate(({ i }) => {
                this.currentIndex = i;
              })
              .onComplete(() => {
                const l = this.list.length;
                let t = targetIndex;
                if (t < this.offset) t += l;
                if (t > l + this.offset - 1) t -= l;
                this.currentIndex = t;
                this.swipeEasing = false;
                this.unbindZing();
              }),
            true
          );
        }
      });
    },
    unbindZing() {
      const detaildialog = document.getElementById('detaildialog');
      if (this.zt) this.zt.unbind(detaildialog);
    },
    onMouseDown(e) {

      this.bindZing();
      this.mouse.state = 'down';
      this.mouse.sx = e.pageX;
      this.mouse.sy = e.pageY;
      this.mouse.index = this.currentIndex;
      if (this.currentEasing) this.currentEasing.stop();
    },
    onMouseMove(e) { //禁止触发click tbd
      
       
        if (this.mouse.state === 'idle') return;
        this.mouse.cx = e.pageX;
        
        this.mouse.cy = e.pageY;
        if(Math.abs(this.mouse.sx - this.mouse.cx) > Math.abs(this.mouse.sy - this.mouse.cy)){// 有效横向滑动
          
          this.onMove();
          if (e.preventDefault){
            e.preventDefault();
          } else {
            e.returnValue = false;
          }
          
        }
    },
    onMouseUp(e) {

      this.mouse.state = 'idle';
      const i = parseInt(this.currentIndex)
      
     
      let iff = (this.currentIndex - i) >ratio
      if(!this.mouse.isForward){
        iff = (this.currentIndex - i) > 1-ratio
      }
      
      const targetIndex = iff?i+1:i//Math.round(this.currentIndex);
      this.setEasing(
        new TWEEN.Tween({
          i: this.currentIndex
        })
          .to(
            {
              i: targetIndex
            },
            150
          )
          .easing(TWEEN.Easing.Quadratic.InOut)
          .onUpdate(({ i }) => {
            this.currentIndex = i;
          })
          .onComplete(() => {
            const l = this.list.length;
            let t = targetIndex;
            if (t < this.offset) t += l;
            if (t > l + this.offset - 1) t -= l;
            this.currentIndex = t;
 
            this.unbindZing();
          }),
        false
      );
      
    }
  },
  beforeDestroy() {
    if (animation) cancelAnimationFrame(animation);
  }
};
</script>
<style scoped lang="less">
.dialog{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
    .swiperitem{
        top:0;
        left:0;
        position: absolute;
    }
    #detaildialog{
      position: relative;
    }
</style>